import React, { useMemo } from 'react';
import { useGeographicData } from '../hooks/useGeographicData';
import { getFlagEmoji } from '../lib/countries';
import { useLanguage } from '../contexts/LanguageContext';

const GeographicFilter = ({
    selectedCountry,
    selectedCity,
    onCountryChange,
    onCityChange,
}) => {
    const { t } = useLanguage();
    const { countries, loading } = useGeographicData();

    const availableCities = useMemo(() => {
        if (!selectedCountry) return [];
        const country = countries.find(c => c.code === selectedCountry);
        return country?.cities || [];
    }, [selectedCountry, countries]);

    if (loading) return null;

    return (
        <div className="flex items-center gap-3">
            <select
                value={selectedCountry}
                onChange={(e) => {
                    onCountryChange(e.target.value);
                    if (onCityChange) onCityChange('');
                }}
                className="border border-border rounded-md px-3 py-2 text-sm focus:outline-none focus:ring-2 focus:ring-accent"
            >
                <option value="">{t('allCountries') || 'Tous les pays'}</option>
                {countries.map(country => (
                    <option key={country.code} value={country.code}>
                        {getFlagEmoji(country.code)} {country.name}
                    </option>
                ))}
            </select>

            {selectedCountry && availableCities.length > 0 && (
                <select
                    value={selectedCity}
                    onChange={(e) => onCityChange && onCityChange(e.target.value)}
                    className="border border-border rounded-md px-3 py-2 text-sm focus:outline-none focus:ring-2 focus:ring-accent"
                >
                    <option value="">{t('allCities') || 'Toutes les villes'}</option>
                    {availableCities.map(city => (
                        <option key={city.name} value={city.name}>
                            {city.name}
                        </option>
                    ))}
                </select>
            )}
        </div>
    );
};

export default GeographicFilter;
